<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     下载二维码
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="qrcode-download"
    width="600px"
    title="下载二维码"
    :visible.sync="dialogShow"
    append-to-body
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :before-close="beforeClose">
    <div style="height: 350px;">
      <template v-if="step == 1">
        <el-form v-loading="posting" ref="downloadForm" :model="downloadForm" :rules="downloadRules" label-position="left" label-width="100px" style="padding: 30px 50px 100px;">
          <el-form-item label="状态筛选" required>
            <el-select v-model="downloadForm.status" style="width: 100%;">
              <el-option v-for="(item, index) in statusTypeArr" :key="index" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="起始序列" prop="start_serial_no">
            <el-input v-model="downloadForm.start_serial_no" />
          </el-form-item>
          <el-form-item label="结束序列" prop="end_serial_no">
            <el-input v-model="downloadForm.end_serial_no" />
          </el-form-item>
        </el-form>
      </template>

      <div v-if="step == 2" class="flex-center column pt-hg">
        <rainbow-loading />
        <div class="text-center mt-lg">正在打包数据......</div>
      </div>

      <div v-if="step == 3" class="flex-center column mb-hg">
        <i class="el-icon-success text-success font-12x"></i>
        <div class="font-lg text-bold mt">打包完成</div>
        <div class="mt">已打包 {{count}} 个二维码和清单</div>
      </div>
    </div>

    <div slot="footer" class="flex-center mb">
      <el-button v-if="step == 1" class="extend" @click="dialogShow = false">取消</el-button>
      <el-button v-if="step == 1" class="extend" type="primary" :loading="posting" @click="submit">确定</el-button>
      <el-button v-if="step == 3" class="extend" @click="close">关闭</el-button>
      <el-button v-if="step == 3" class="extend" type="primary" :loading="posting" @click="download">下载压缩包</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { codeDownloadApi, codeDownloadDeleteApi } from "@/api/fam/famCodeApi";
import { validateNumber } from "@/utils/validate";

export default {
  name: 'QrcodeDownload',

  components: {
    RainbowLoading: () => import("./RainbowLoading"),
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    start: {
      type: Number,
      default: null
    },

    end: {
      type: Number,
      default: null
    },
  },

  data() {
    var validateNo = (rule, value, callback) => {
      value = +value
      if (!value) {
        callback(new Error('请输入正确的序列！'))
      } else {
        if (validateNumber(value)) {
          if (value > 100000) return callback(new Error('请输入正确的序列！'))
          if (this.downloadForm.start_serial_no && this.downloadForm.end_serial_no && +this.downloadForm.start_serial_no > +this.downloadForm.end_serial_no) {
            return callback(new Error('起始序列应小于等于结束序列！'))
          }
          // this.clear()
          callback()
        } else {
          return callback(new Error('请输入正确的序列！'))
        }
      }
    }

    return {
      step: 1,
      count: null,
      file_path: '',
      posting: false,
      downloadForm: {
        start_serial_no: null,
        end_serial_no: null,
        status: 0
      },

      downloadRules: {
        start_serial_no: [
          { required: true, message: "起始序列不能为空", trigger: "blur" },
          { validator: validateNo, trigger: "blur" }
        ],
        end_serial_no: [
          { required: true, message: "结束序列不能为空", trigger: "blur" },
          { validator: validateNo, trigger: "blur" }
        ],
      },

      statusTypeArr: [
        { value: 0, title: "全部" },
        { value: 1, title: "未激活" },
        { value: 2, title: "已激活" },
        { value: 3, title: "已查验" },
        { value: 4, title: "已核销" },
      ],
      
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
    if (this.start && this.end) {
      this.downloadForm.start_serial_no = this.start
      this.downloadForm.end_serial_no = this.end
    } 
  },

  methods: {
    submit() {
      this.$refs['downloadForm'].validate(valid => {
        if (valid) {
          this.posting = true
          this.step = 2
          codeDownloadApi(this.downloadForm).then((res) => {
            this.posting = false
            if (res.errno === 0) {
              this.file_path = res.data.file_path
              this.count = res.data.count
              this.step = 3
            } else {
              this.step = 1
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    download() {
      if (this.posting) return
      this.posting = true
      window.open(this.file_path, '_blank')
      const _this = this
      setTimeout(() => {
        _this.posting = false
      }, 100)
    },

    beforeClose(done) {
      if (this.step !== 3 && this.posting) {
        this.$message.warning('正在打包数据，请耐心等待！')
        return
      }
      if (this.step == 3) {
        codeDownloadDeleteApi({ file_path: this.file_path }).then((res) => {
          done()
        })
      }
      done()
    },

    close() {
      codeDownloadDeleteApi({ file_path: this.file_path }).then((res) => {
        this.dialogShow = false
      })
    },

    clear() {
      this.$nextTick(() => {
        this.$refs['downloadForm'].clearValidate()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.qrcode-create {
  .el-alert--blue.is-light {
    background-color: rgba(64,158,255,0.1);
  }
}
</style>
